import Client from '../services/kenticoClient';
import { KENTICO_TYPES } from '../common/consts/kentico';

class PersonService {
  async fetchPeople() {
    return Client.items()
      .type(KENTICO_TYPES.TEAM_OF_EXPERTS)
      .toPromise();
  }
}

export default new PersonService();



// WEBPACK FOOTER //
// ./src/services/Person.service.js